






























import Vue from "vue";

export default Vue.extend({
  props: {
    successMessage: String,
    errorMessage: String,
    loading: Boolean,
    retry: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog(): boolean {
      return (
        this.loading || this.errorMessage != "" || this.successMessage != ""
      );
    },
    showLoading(): boolean {
      return (
        this.loading && this.errorMessage === "" && this.successMessage === ""
      );
    },
    success(): boolean {
      return this.successMessage != "";
    },
    failure(): boolean {
      return this.errorMessage != "";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    retryOp() {
      this.$emit("retry");
    },
  },
});
